import { useSelector } from 'react-redux';
import { mainSelector } from '$store/main';

export const useHasSubscription = (authorId: number) => {
  const { decryptKeys } = useSelector(mainSelector);

  return authorId > 0 && decryptKeys[authorId];
};
